import { DocumentServicePath } from "utils/constants";

export const documentRequests = {
  getDeclarationsSelect: () => `${DocumentServicePath}selects/declarations`,
  getDynamicDeclarationsSelect: () => `${DocumentServicePath}selects/dynamic-declarations`,
  getDeclarationById: id => `${DocumentServicePath}declarations/${id}/documents`,
  updateDeclaration: id => `${DocumentServicePath}declarations/documents/${id}`,
  getDocumentById: (id, type) => `${DocumentServicePath}${type}-documents/${id}`,
  postPrivateDocuments: () => `${DocumentServicePath}private-documents`,
};
